exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-item{font-size:12px}.option-item.collapsible-item .item-heading{display:flex;flex-flow:row;justify-content:space-between}.reset-button{margin-right:20px;color:#bbb;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af3b01ee","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/options/OptionGroup.vue
// module id = 100
// module chunks = 0 1